/*
  Order page status — reads the shared schedule and tells people whether the
  truck is serving right now or when the kitchen opens next. Informational
  only: it never disables the order buttons, because DoorDash and Grubhub
  manage their own open/closed state.
*/
(function () {
  'use strict';

  var MIN_PER_DAY = 1440;
  var WEEK_MIN = MIN_PER_DAY * 7;
  var DAY_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  function parseClock(value) {
    if (value === 0) { return 0; }
    if (!value) { return null; }
    var raw = String(value).trim().toUpperCase();
    var isPm = raw.indexOf('PM') > -1;
    var isAm = raw.indexOf('AM') > -1;
    raw = raw.replace(/[AP]M/g, '').trim();
    var parts = raw.split(':');
    var h = parseInt(parts[0], 10);
    var m = parts.length > 1 ? parseInt(parts[1], 10) : 0;
    if (isNaN(h)) { return null; }
    if (isNaN(m)) { m = 0; }
    if (isPm && h < 12) { h += 12; }
    if (isAm && h === 12) { h = 0; }
    return (h * 60) + m;
  }

  function formatClock(total) {
    var mins = ((total % MIN_PER_DAY) + MIN_PER_DAY) % MIN_PER_DAY;
    var h = Math.floor(mins / 60), m = mins % 60;
    var sfx = h >= 12 ? 'PM' : 'AM';
    var d = h % 12;
    if (d === 0) { d = 12; }
    return d + ':' + (m < 10 ? '0' + m : m) + ' ' + sfx;
  }

  function build(slots) {
    var out = [];
    for (var i = 0; i < slots.length; i++) {
      var s = slots[i];
      var day = parseInt(s.day, 10);
      var st = parseClock(s.start), en = parseClock(s.end);
      if (isNaN(day) || st === null || en === null) { continue; }
      var a = day * MIN_PER_DAY + st, b = day * MIN_PER_DAY + en;
      if (b <= a) { b += MIN_PER_DAY; }
      out.push({ name: s.name || '', day: day, start: a, end: b, startClock: st });
    }
    return out;
  }

  function init(root) {
    var dataEl = root.querySelector('[data-wb-order-schedule]');
    var statusEl = root.querySelector('[data-wb-order-status]');
    var textEl = root.querySelector('[data-wb-order-text]');
    if (!dataEl || !statusEl || !textEl) { return; }

    var slots = [];
    try { slots = JSON.parse(dataEl.textContent || '[]'); } catch (e) { return; }
    var windows = build(slots);
    if (!windows.length) { statusEl.style.display = 'none'; return; }

    var now = new Date();
    var current = now.getDay() * MIN_PER_DAY + now.getHours() * 60 + now.getMinutes();

    var active = null;
    var offs = [0, -WEEK_MIN, WEEK_MIN];
    for (var i = 0; i < windows.length && !active; i++) {
      for (var o = 0; o < offs.length; o++) {
        var s = windows[i].start + offs[o];
        var e = windows[i].end + offs[o] + 15;
        if (current >= s && current < e) { active = windows[i]; break; }
      }
    }

    var liveUrl = root.getAttribute('data-live');
    var liveStale = parseInt(root.getAttribute('data-live-stale') || '240', 10);
    if (liveUrl && window.wbLiveGps) {
      window.wbLiveGps(liveUrl, liveStale, function (ping) {
        if (!ping) { return; }
        statusEl.classList.add('is-live');
        textEl.textContent = 'THE TRUCK IS LIVE' + (ping.label ? ' \u2014 ' + ping.label : '');
      });
    }

    if (active) {
      statusEl.classList.add('is-live');
      textEl.textContent = 'THE TRUCK IS LIVE \u2014 ' + active.name;
      return;
    }

    var best = null, delta = Infinity;
    for (var j = 0; j < windows.length; j++) {
      for (var k = 0; k < 2; k++) {
        var d = (windows[j].start + k * WEEK_MIN) - current;
        if (d > 0 && d < delta) { delta = d; best = windows[j]; }
      }
    }
    if (best) {
      textEl.textContent = 'Kitchen opens ' + DAY_SHORT[best.day] + ' ' + formatClock(best.startClock);
    } else {
      statusEl.style.display = 'none';
    }
  }

  function boot() {
    var roots = document.querySelectorAll('[data-wb-order]');
    for (var i = 0; i < roots.length; i++) { init(roots[i]); }
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }

  document.addEventListener('shopify:section:load', function (e) {
    var n = e.target.querySelector ? e.target.querySelector('[data-wb-order]') : null;
    if (n) { init(n); }
  });
})();
